// extracted by mini-css-extract-plugin
module.exports = {"head":"Index_head__3YPGy"};